export const environment = {
  production: false,

  firebaseConfig : {
    apiKey: "AIzaSyArYNz9X1PSg7DX7UpJtwnQC8liF_WXdeo",
    authDomain: "om-sai-enterprises-786.firebaseapp.com",
    databaseURL: "https://om-sai-enterprises-786-default-rtdb.firebaseio.com",
    projectId: "om-sai-enterprises-786",
    storageBucket: "om-sai-enterprises-786.appspot.com",
    messagingSenderId: "529245401178",
    appId: "1:529245401178:web:d65ea27ea3520584d86863"
  }
};